import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadTerritories } from './actions';
import List from './List';
import { Panel } from 'react-bootstrap';

class Territories extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, ...listPagination });
	}

	render() {
		return <Panel>
			<Panel.Body>
				<List franchiseeId={this.props.franchiseeId} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { territories } } = state;

	const territoriesPagination = pagination.territoriesByFranchisee[ownProps.franchiseeId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: territoriesPagination.ids.map(id => territories[id]),
		pagination: territoriesPagination
	};
};

Territories.propTypes = {
	franchiseeId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadTerritories
})(Territories);